import gql from "graphql-tag";

// InsertProjectSpecialConditionTypeMapping + the project's trail row in ONE document. Hasura runs
// all root mutation fields of a single document in one transaction, so the change and its history
// line can never exist without each other.
//
// The trail row is display-only (see specialConditionVersionSnapshot.ts) — the mapping's STATE is
// the row below, scoped by revision_id, which the BEFORE INSERT trigger stamps from the project's
// current revision. revision_id is deliberately not in the insert permission's column list, so
// this write always lands on the working state and can never forge history.
//
// The on_conflict constraint name is the pre-rename, Postgres-truncated one — it covers four
// columns (model, project_id, type_identifier, revision_id) while naming three. Hasura's
// on_conflict names the CONSTRAINT rather than its columns, so Hasura migration 1786991100472
// recreated it under exactly this name to keep this document working.
const InsertProjectSpecialConditionTypeMappingWithVersionMutation = gql`
  mutation InsertProjectSpecialConditionTypeMappingWithVersion(
    $areaOfConstruction: numeric
    $description: String
    $length: numeric
    $model: String!
    $projectId: uuid!
    $specialConditionTypeId: uuid!
    $typeIdentifier: String!
    $version: projectVersion_insert_input!
  ) {
    insert_projectSpecialConditionTypeMapping(
      objects: {
        areaOfConstruction: $areaOfConstruction
        description: $description
        length: $length
        model: $model
        projectId: $projectId
        specialConditionTypeId: $specialConditionTypeId
        typeIdentifier: $typeIdentifier
      }
      on_conflict: {
        constraint: project_special_condition_type_mapping_model_project_id_type_id
        update_columns: [areaOfConstruction, description, length, model, specialConditionTypeId]
      }
    ) {
      returning {
        typeIdentifier
        specialConditionTypeId
        projectId
        model
        length
        id
        description
        areaOfConstruction
      }
    }
    insert_projectVersion_one(object: $version) {
      id
    }
  }
`;

export default InsertProjectSpecialConditionTypeMappingWithVersionMutation;
